module.exports = __webpack_public_path__ + "static/media/slices5@2x.2c3c13aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slices5@2x.png
// module id = 764
// module chunks = 0 1